<script setup lang="ts">
// Organiser logo shown in every "Organised by" card. Uploaded logos have no
// constraint on size or aspect ratio (see UploadOrganisationLogoRequest), so
// this component always scales the logo down to fit inside a fixed box
// (object-contain) instead of cropping it (object-cover) - see GitHub issue #220.
withDefaults(
  defineProps<{
    /** Logo URL, or null/undefined to render the placeholder icon. */
    src?: string | null
    /** Alt text for the logo image. */
    alt: string
    /** Box size variant. `md` is used by the participant registration detail page, `sm` everywhere else. */
    size?: 'sm' | 'md'
  }>(),
  {
    src: null,
    size: 'sm',
  },
)

const boxSizeClasses: Record<'sm' | 'md', string> = {
  sm: 'w-10 h-10 rounded-lg',
  md: 'w-12 h-12 rounded-xl',
}

const iconSizeClasses: Record<'sm' | 'md', string> = {
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
}
</script>

<template>
  <img
    v-if="src"
    :src="src"
    :alt="alt"
    class="object-contain bg-white border border-slate-100 p-1 shrink-0"
    :class="boxSizeClasses[size]"
  />
  <div
    v-else
    class="bg-slate-100 flex items-center justify-center shrink-0"
    :class="boxSizeClasses[size]"
  >
    <svg
      :class="iconSizeClasses[size]"
      class="text-slate-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
      />
    </svg>
  </div>
</template>
